import React from 'react';

import { Link } from 'react-router-dom';

const style = 'text-indigo-500 underline';

export default function LinkComponent({ value, col, row, isOuter }) {
  if (isOuter) {
    return (
      <a
        className={style}
        href={col.link(row)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </a>
    );
  }

  return (
    <Link className={style} to={col.link(row)}>
      {value}
    </Link>
  );
}
